import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter, OnInit } from '@angular/core';

import { IDashBoardAdminChartDetailsWithProvider } from '../dasboard-admin-chart-details.model';
import { ChartValue } from '../chart/chart-value.model'
import { ViewsTypes } from './views.types';
import { DateHelperService } from '../../core/services';
import { LineChartOptions } from "../chart/line-chart-options.model";
import { WebWorkerService } from 'angular2-web-worker/web-worker.service';

@Component({
    moduleId: module.id,
    selector: 'views',
    templateUrl: 'views.component.html'
})
export class ViewsComponent implements OnInit, OnChanges {
    @Input() data: IDashBoardAdminChartDetailsWithProvider;
    @Input() dataForToday: IDashBoardAdminChartDetailsWithProvider;
    @Input() totalUniques: number;
    @Input() period: string;
    @Input() showTopSectionOverlay: boolean;
    triggerChange: Date;
    totalRequests: number = 0;
    totalPlaysStarted: number = 0;
    totalCompletedViews: number = 0;
    chartValues: ChartValue[] = new Array<ChartValue>();
    toolTipText: string = "{0} {1}";
    chartOptions: LineChartOptions = new LineChartOptions();;
    @Output() loaded: EventEmitter<any> = new EventEmitter<Event>();

    constructor(
        private dateHelper: DateHelperService,
        private webWorkerService: WebWorkerService) {
    }

    ngOnInit() {
        this.chartOptions.formatTooltip = '1.0';
    }

    private mapAllData(): void {
        this.totalRequests = 0;
        this.totalPlaysStarted = 0;
        this.totalCompletedViews = 0;
        this.chartValues = new Array<ChartValue>();
        let requestChartValue = new ChartValue(ViewsTypes.Requests);
        requestChartValue.identifier = ViewsTypes.Requests;
        let playedChartValue = new ChartValue(ViewsTypes.PlaysStarted);
        playedChartValue.identifier = ViewsTypes.PlaysStarted;
        let completedChartValue = new ChartValue(ViewsTypes.PlaysCompleted);
        completedChartValue.identifier = ViewsTypes.PlaysCompleted;

        for (let item of this.data.completed) {
            completedChartValue.data.push([this.dateHelper.getTicks(item.dateUtc), item.count]);
            completedChartValue.lastItemIdentifier = item.dateUtc;
            this.totalCompletedViews += item.count;
        }
        for (let item of this.data.played) {
            playedChartValue.data.push([this.dateHelper.getTicks(item.dateUtc), item.count]);
            playedChartValue.lastItemIdentifier = item.dateUtc;
            this.totalPlaysStarted += item.count;
        }
        for (let item of this.data.requests) {
            requestChartValue.data.push([this.dateHelper.getTicks(item.dateUtc), item.count]);
            requestChartValue.lastItemIdentifier = item.dateUtc;
            this.totalRequests += item.count;
        }
        this.chartValues.push(requestChartValue, playedChartValue, completedChartValue);
        this.loaded.emit(true);
    }

    private mapTodayData(params: any): void {
        Array.prototype.findIndex || Object.defineProperty(Array.prototype, "findIndex", { value: function (r) { if (null == this) throw new TypeError('"this" is null or not defined'); var e = Object(this), t = e.length >>> 0; if ("function" != typeof r) throw new TypeError("predicate must be a function"); for (var n = arguments[1], o = 0; o < t;) { var i = e[o]; if (r.call(n, i, o, e)) return o; o++ } return -1 } }), Array.prototype.find || Object.defineProperty(Array.prototype, "find", { value: function (r) { if (null == this) throw new TypeError('"this" is null or not defined'); var e = Object(this), t = e.length >>> 0; if ("function" != typeof r) throw new TypeError("predicate must be a function"); for (var n = arguments[1], o = 0; o < t;) { var i = e[o]; if (r.call(n, i, o, e)) return i; o++ } } });
        let requestChartValues = params.chartValues.find(x => x.identifier == params.Requests);
        if (requestChartValues) {
            for (let item of params.dataForToday.requests) {
                if (formatDate(item.dateUtc) == formatDate(requestChartValues.lastItemIdentifier)) {
                    let lastCount = requestChartValues.data[requestChartValues.data.length - 1][1];
                    params.totalRequests = params.totalRequests - lastCount + item.count;
                    requestChartValues.data[requestChartValues.data.length - 1][1] = item.count;
                }
            }
        }

        let completedChartValues = params.chartValues.find(x => x.identifier == params.PlaysCompleted);
        if (completedChartValues) {
            for (let item of params.dataForToday.completed) {
                if (formatDate(item.dateUtc) == formatDate(completedChartValues.lastItemIdentifier)) {
                    let lastCount = completedChartValues.data[completedChartValues.data.length - 1][1];
                    params.totalCompletedViews = params.totalCompletedViews - lastCount + item.count;
                    completedChartValues.data[completedChartValues.data.length - 1][1] = item.count;
                }
            }
        }

        let playedChartValues = params.chartValues.find(x => x.identifier == params.PlaysStarted);
        if (playedChartValues) {
            for (let item of params.dataForToday.played) {
                if (formatDate(item.dateUtc) == formatDate(playedChartValues.lastItemIdentifier)) {
                    let lastCount = playedChartValues.data[playedChartValues.data.length - 1][1];
                    params.totalPlaysStarted = params.totalPlaysStarted - lastCount + item.count;
                    playedChartValues.data[playedChartValues.data.length - 1][1] = item.count;
                }
            }
        }
        function formatDate(date: Date) {
            let _date = new Date(date);
            let day = _date.getDate();
            let monthIndex = _date.getMonth();
            let year = _date.getFullYear();
            return year + '-' + monthIndex + '-' + day;
        }
        return params;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.data && changes["data"] && changes["data"].previousValue != changes["data"].currentValue) {
            this.mapAllData();
        }
        if (this.dataForToday && !changes["data"]) {
            let params = {
                dataForToday: this.dataForToday,
                chartValues: this.chartValues,
                totalRequests: this.totalRequests,
                totalCompletedViews: this.totalCompletedViews,
                totalPlaysStarted: this.totalPlaysStarted,
                Requests: ViewsTypes.Requests,
                PlaysCompleted: ViewsTypes.PlaysCompleted,
                PlaysStarted: ViewsTypes.PlaysStarted
            }
            if (typeof (Worker) !== "undefined") {
                this.webWorkerService.run(this.mapTodayData, params).then((res) => {
                    this.onMapTodayData(res);
                }).catch((r) => { console.log(r) });
            } else {
                let res = this.mapTodayData(params);
                this.onMapTodayData(res);
            }
        }
    }

    private onMapTodayData(res: any) {
        this.dataForToday = res.dataForToday;
        this.chartValues = res.chartValues;
        this.totalRequests = res.totalRequests;
        this.totalCompletedViews = res.totalCompletedViews;
        this.totalPlaysStarted = res.totalPlaysStarted;
        this.loaded.emit(true);
        this.triggerChange = new Date();
    }

}


// WEBPACK FOOTER //
// ./src/app/dashboard/views/views.component.ts